import React, { useCallback, useState } from 'react';
import MiniModal from './MiniModal';
import ButtonNew from './inputs/ButtonNew';
import Checkbox from './inputs/Checkbox';
import './BulkDeleteModal.scss';
import classNames from 'classnames';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const BulkDeleteModal = ({
  onExit,
  onConfirm,
  onCancel,
  matrixNames,
  disabled,
}) => {
  return (
    <MiniModal onExit={onExit} dark={true}>
      <div className="BulkDeleteModal">
        <div className="BulkDeleteModal-header-text">
          <div className="BulkDeleteModal-header-text red">Warning</div>
          <div className="BulkDeleteModal-header-text">
            Are you sure you want to delete {matrixNames.length} matrices?
          </div>
        </div>

        <div className="BulkDeleteModal-name-container">
          {matrixNames.map((name, i) => (
            <div key={i} className="BulkDeleteModal-name">
              {name}
            </div>
          ))}
        </div>

        <div className="BulkDeleteModal-buttons-container">
          <div className="BulkDeleteModal-button-container">
            <ButtonNew
              buttonClasses="secondary-button-dark-small BulkDeleteModal-button"
              onClick={onCancel}
              label="Cancel"
            />
          </div>
          <div
            className="BulkDeleteModal-button-container"
            data-tooltip-id={disabled ? 'loading-tooltip' : null}
            data-tooltip-content="Matrix needs to be loaded before deletion"
            data-tooltip-place="bottom"
          >
            <ButtonNew
              buttonClasses={classNames(
                'primary-button-small BulkDeleteModal-button BulkDeleteModal-button-destructive',
                {
                  disabled,
                }
              )}
              onClick={onConfirm}
              label="Delete"
            />
          </div>
        </div>
      </div>
      <ReactTooltip id="loading-tooltip" className="react-tooltip" />
    </MiniModal>
  );
};

export default BulkDeleteModal;
